<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="CASH_CALL_SANCTIONS_CHECK_OPTIONS"      
      size="sm"
      label="Sanctions Check"
      rules="required"
    >
      <template v-slot:label>Sanctions Check <span class="text-danger">*</span> </template>
  
      <!-- <template v-slot:first>
        <b-form-select-option :value="undefined"
          >Select</b-form-select-option
        >
      </template> -->
    </BaseSelect>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'  
  import { CASH_CALL_SANCTIONS_CHECK_OPTIONS } from '@constants'  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallFormSanctionsCheckStatus',
    components: {
      BaseSelect
    },
    props: {
      value: String
    },
    emits: ['input'],
    setup(props, { emit }) {   
  
      const displayflex = "displayflex"

      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })   
  
      return {
        CASH_CALL_SANCTIONS_CHECK_OPTIONS,  
        modelValue
      }
    }
  })
  </script>
  